import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Person} from '../../class/person';
import {PersonKind} from '../../class/person-kind.enum';

@Component({
  selector: 'app-person-chooser',
  templateUrl: './person-chooser.component.html',
  styleUrls: ['./person-chooser.component.css']
})
export class PersonChooserComponent implements OnInit {

  @Input()
  people: Person[] = [];

  @Output()
  onPersonSelected = new EventEmitter<Person>();

  @Input()
  excludedPerson: Person;

  readonly kindChild = PersonKind.CHILD;

  constructor() {
  }

  ngOnInit() {
    console.log('init');
  }

  personSelected(person: Person) {
    this.onPersonSelected.emit(person);
  }

}
